import { on } from 'delegated-events'
import qs from 'qs'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import '@styles/components/datepicker.css'
import NProgress from 'nprogress'
import ajax from '@common/ajax'

const form = document.querySelector('.filter-form')
const calendarSearchForm = document.querySelector('.calendar-filter-search')

const setupCalendarField = () => {
  flatpickr(form.querySelector('.filter-date'), {
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: 'M J',
    disableMobile: true,
    monthSelectorType: 'static',
    minDate: new Date(),
    mode: 'range',
    position: window.matchMedia('(min-width: 768px)').matches ? 'auto left' : 'auto left',
    onChange: (_, __, instance) => {
      if (!instance.isOpen) {
        handleFilterChange()
      }
    },
    onClose: (selectedDates, __, instance) => {
      if (selectedDates.length === 1) {
        setTimeout(() => {
          instance.setDate(selectedDates[0], true)
        }, 0)
      }
    },
  })
}

const populateFilterState = () => {
  const filters = JSON.parse(form.dataset.selectedFilters)

  const types = ['exhibitions', 'categories', 'audiences']

  types.forEach((type) => {
    if (type in filters) {
      filters[type].forEach((value) => {
        const field = form.querySelector(`[value="${value}"]`)

        if (field) {
          field.checked = true
        }
      })
    }
  })
}

const generateUrl = (params = {}) => {
  const query = qs.stringify(params, { filter: (_, value) => value || undefined })
  const queryStr = query ? `?${query}` : ''

  return `${form.action}${queryStr}`
}

const handleFilterChange = (e) => {
  e && e.preventDefault()

  const searchTerm = form.querySelector('.filter-search').value
  const selectedCategories = Array.from(form.querySelectorAll('.filter-category:checked'))
  const selectedAudiences = Array.from(form.querySelectorAll('.filter-audience:checked'))
  const selectedDate = form.querySelector('.filter-date[type="hidden"]').value

  const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })

  const params = {}

  params.search = searchTerm
  params.categories = selectedCategories.map((x) => x.value).join('_')
  params.audiences = selectedAudiences.map((x) => x.value).join('_')
  params.date = selectedDate.replace(' to ', '_')

  if (currentParams.view) {
    params.view = currentParams.view
  }

  const url = generateUrl(params)

  window.history.replaceState({}, '', url)

  updateResults()
}

const handleFilterClear = (e) => {
  const targetFilter = e.currentTarget.dataset.target

  if (targetFilter === '_all_') {
    form.querySelectorAll('input[type="checkbox"]').forEach((x) => (x.checked = false))
    form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null))
    form.querySelectorAll('input[type="text"]').forEach((x) => (x.value = null))

    calendarSearchForm.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null))

    const dateField = form.querySelector('.filter-date')

    if (dateField) {
      dateField._flatpickr.clear()
    }

    handleFilterChange()

    return
  }

  if (targetFilter === '_date_') {
    const dateField = form.querySelector('.filter-date')

    if (dateField) {
      dateField._flatpickr.clear()
    }

    handleFilterChange()
  }

  const targetCheckbox = form.querySelector(`input[type="checkbox"][value="${targetFilter}"]`)

  if (targetCheckbox) {
    targetCheckbox.checked = false
    handleFilterChange()
  }
}

const handleViewToggle = (e) => {
  const toggles = document.querySelectorAll('.view-toggle')
  const groupedDates = document.querySelector('.event-grouped-dates')
  const selectedView = e.currentTarget.dataset.view

  groupedDates.classList.remove('as-grid', 'as-list')
  groupedDates.classList.add(`as-${selectedView}`)

  toggles.forEach((x) => {
    x.disabled = false
    x.setAttribute('aria-pressed', 'false')
  })

  e.currentTarget.setAttribute('aria-pressed', 'true')
  e.currentTarget.disabled = true

  const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  currentParams.view = selectedView

  const url = generateUrl(currentParams)

  window.history.replaceState({}, '', url)
}

const updateResults = async () => {
  const pageContent = document.querySelector('[data-page-content]')
  const selectedFilters = document.querySelector('[data-page-selected-filters]')

  if (pageContent) {
    NProgress.start()
    pageContent.classList.add('is-loading')

    const res = await ajax.get(window.location.href).json()

    NProgress.done()
    selectedFilters.innerHTML = res.selectedFilters
    pageContent.innerHTML = res.page
    pageContent.classList.remove('is-loading')
  }
}

const init = () => {
  populateFilterState()
  setupCalendarField()

  NProgress.configure({ parent: '.calendar-loading-progress' })

  on('change', '.filter-form input:not([type=hidden]):not([type=search])', handleFilterChange)
  on('submit', '.filter-form', handleFilterChange)
  on('click', '.clear-filter-btn', handleFilterClear)
  on('click', '.view-toggle:not([disabled])', handleViewToggle)
  on('click', '.show-filters-btn', () => {
    document.documentElement.classList.add('overflow-hidden')
    document.querySelector('.calendar-filters').classList.add('is-active')
    document.querySelector('.sticky').classList.remove('z-30')
    document.querySelector('.sticky').classList.add('-z-1')
  })
  on('click', '.hide-filters-btn', () => {
    document.documentElement.classList.remove('overflow-hidden')
    document.querySelector('.calendar-filters').classList.remove('is-active')
    document.querySelector('.sticky').classList.remove('-z-1')
    document.querySelector('.sticky').classList.add('z-30')
  })
}

init()
